// extracted by mini-css-extract-plugin
module.exports = {"root":"Comment_root_23uOu","badges":"Comment_badges_2oBVK","controls":"Comment_controls_3_4ce","answer":"Comment_answer_3_24j"};